<template>
  <section>
    <base-container>
      <div class="inner-container">
        <div class="draft">
          <p>選擇服務</p>
          <div class="selection">
            <el-row :gutter="5">
              <el-col :span="12">
                <el-button
                  @click="activate('america')"
                  class="btn-selection"
                  :class="{ 'is-selected': selectedOption === 'america' }"
                  type="primary"
                  >美國</el-button
                >
              </el-col>
              <el-col :span="12">
                <el-button
                  @click="activate('japan')"
                  class="btn-selection"
                  :class="{ 'is-selected': selectedOption === 'japan' }"
                  type="primary"
                  >日本</el-button
                >
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :span="12">
                <el-button
                  @click="activate('uk')"
                  class="btn-selection"
                  :class="{ 'is-selected': selectedOption === 'uk' }"
                  type="primary"
                  >英國</el-button
                >
              </el-col>
              <el-col :span="12">
                <el-button
                  @click="activate('taiwan')"
                  class="btn-selection"
                  :class="{ 'is-selected': selectedOption === 'taiwan' }"
                  type="primary"
                  >台灣</el-button
                >
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :span="12">
                <el-button
                  @click="activate('australia')"
                  class="btn-selection"
                  :class="{ 'is-selected': selectedOption === 'australia' }"
                  type="primary"
                  >澳洲</el-button
                >
              </el-col>
              <el-col :span="12">
                <el-button
                  @click="activate('germany')"
                  class="btn-selection"
                  :class="{ 'is-selected': selectedOption === 'germany' }"
                  type="primary"
                  >德國</el-button
                >
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </base-container>
  </section>
</template>

<script>
export default {
  data() {
    return {
      selectedOption: "america",
    };
  },
  methods: {
    activate(option) {
      this.selectedOption = option;
    },
  },
};
</script>


<style scoped>
.inner-container {
  padding: 0 5rem;
}

.draft {
  margin-top: 3rem;
}

.draft p {
  margin-bottom: 1rem;
}

.selection {
  background-color: #fff;
  border-radius: 12px;
  /* min-width: 990px; */
  padding: 0.3rem;
}

.selection .el-row:not(:last-of-type) {
  margin-bottom: 0.5rem;
}

.btn-selection {
  width: 100%;
  padding: 1.3rem;
  border-radius: 12px;
  background-color: #f0f0f0;
  border-color: #f0f0f0;
  color: #333333;
}

.btn-selection:hover,
.btn-selection:focus {
  background-color: #7a3d87;
  border-color: #7a3d87;
}
.is-selected {
  background-color: #7a3d87;
  border-color: #7a3d87;
  color: #fff;
}
</style>